import { useMemo } from 'react';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { useStore } from '../../store';
import { getTenantNameBySubdomain } from '../../utils/getTenantNameBySubdomain';
import { HttpError } from '../errors';
import {
  getPublicApiHeaders,
  portalGatewayClient,
} from '../portalGatewayClient';

export const getTenantLoginInfo = async (initializeSession = false) => {
  const res = await portalGatewayClient.publicApi.getLoginInfo({
    headers: getPublicApiHeaders(),
  });
  if (res.ok) {
    if (initializeSession) {
      const { apiId } = res.data.data;
      if (apiId) {
        const { setApiId, initSession } = useStore.getState();
        setApiId(apiId);
        await initSession(apiId);
      } else {
        throw new HttpError('API ID is required.', { ...res, status: 400 });
      }
    }
    return res.data.data;
  }
  throw new HttpError('Fetching tenant login info failed.', res);
};

const queryOptions = {
  queryKey: ['tenantLoginInfo'],
  gcTime: Infinity,
  staleTime: Infinity,
};

export function useLoginInfoSuspenseQuery() {
  return useSuspenseQuery({
    ...queryOptions,
    queryFn: () => getTenantLoginInfo(true),
    retry: false,
  });
}

export function useLoginInfoQuery() {
  const tenantNameFromStore = useStore((state) => state.tenantName);
  const tenantFromHost = useMemo(() => {
    try {
      return getTenantNameBySubdomain();
    } catch {
      return undefined;
    }
  }, []);

  return useQuery({
    ...queryOptions,
    queryFn: () => getTenantLoginInfo(),
    enabled: tenantNameFromStore != null || tenantFromHost != null,
    notifyOnChangeProps: ['data', 'error'],
  });
}
